import React, { useContext, useEffect, useState } from "react";
import themeContext from "../../../context/theme/ThemeContext";
import { API_BASE_URL, resolveBackendForHost } from "../../../constants/Constants";
import { getEnv } from '../../../helpers/EnvHelper';

const RebrandingLogo = ({ fallback }) => {
  const { themeName } = useContext(themeContext);
  const [useFallback, setUseFallback] = useState(false);

  const isVdc = getEnv("REACT_APP_VDC_PLATFORM") === "true";
  const theme = themeName === "light" ? "light" : "dark";
  const logoUrl = `${API_BASE_URL}rebranding/logo?theme=${theme}`;
  const { logoWidth, logoHeight } = resolveBackendForHost(window.location.host);

  // ✅ Hooks are ALWAYS called
  useEffect(() => {
    setUseFallback(false);
  }, [theme]);

  // 🔒 VDC FLOW — unchanged, no backend call
  if (isVdc) {
    return fallback;
  }

  // 🔁 Backend failed → fallback
  if (useFallback) {
    return fallback;
  }

  // 🎨 Non-VDC → backend branding
  return (
    <img
      src={logoUrl}
      alt="Logo"
      style={{width: logoWidth || "111px", height: logoHeight || "25px"}}
      onError={() => setUseFallback(true)}
    />
  );
};

export default RebrandingLogo;
